sew-ws-image-text {
    --grid-row: 1;

    display: block;

    &:not([no-grid]) {
        @include grid;
    }

    &:not([no-margin]) {
        @include component-spacing;
    }

    .main-content-container {
        grid-row: 1;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        align-items: start;
        column-gap: var(--column-gap);

        > h2 {
            @include typo-ws-h2;

            margin: 0 0 24px;
            grid-column: 1 / span 8;
        }

        .slot-wrapper {
            display: contents;

            *:first-child {
                grid-column: 1 / span var(--span-first);
                grid-row: var(--grid-row);
            }
            *:last-child {
                grid-column: calc(var(--span-first) + 1) / span var(--span-last);
                grid-row: var(--grid-row);
            }
        }
    }

    &[reverse] {
        .main-content-container {
            .slot-wrapper {
                *:first-child {
                    grid-column: calc(var(--span-last) + 1) / span var(--span-first);
                }

                *:last-child {
                    grid-column: 1 / span var(--span-last);
                }
            }
        }
    }

    &.has-headline {
        --grid-row: 2;
    }

    &[size='xxs'] {
        --span-first: 3;
        --span-last: 9;
    }

    &[size='xs'] {
        --span-first: 4;
        --span-last: 8;
    }

    &[size='small'] {
        --span-first: 5;
        --span-last: 7;
    }

    &[size='medium'] {
        .main-content-container {
            > h2 {
                grid-column: 1 / span 7;
            }
        }

        --span-first: 7;
        --span-last: 5;
    }

    &[size='large'] {
        --span-first: 8;
        --span-last: 4;
    }

    &.tab-item[size='large'] {
        sew-ws-richtext {
            margin: 60px 0;
        }
    }

    &.tab-item[size='small'] {
        sew-ws-richtext {
            margin: 24px 0;
        }
    }

    &.tile-gallery-item[slot='keyvisual'] {
        sew-ws-richtext {
            margin: 40px 0 0 var(--content-padding);
        }
    }

    .underlay {
        display: none;
    }

    &[underlay] {
        .underlay {
            display: block;
            background-color: $color-grey-06-bright;
            grid-column: 1 / -1;
            grid-row: 1;
        }

        .main-content-container {
            padding: 40px 0 60px;
            align-items: center;
        }
    }

    &[small-margin] {
        margin-top: 40px;
    }

    &:not(.tab-item) {
        sew-ws-richtext {
            align-self: center;
        }
    }

    &:not(.tab-item).has-caption {
        sew-ws-richtext {
            margin-bottom: 28px;
        }
    }

    @include mq-3 {
        &.tab-item[size='large'] {
            sew-ws-richtext {
                margin: 36px 0;
            }
        }
    }

    @include mq-2 {
        .main-content-container {
            > h2 {
                grid-column: 1 / span 12;
            }
        }

        &[size='xs'] {
            --span-first: 5;
            --span-last: 7;
        }

        &[size='small'] {
            --span-first: 6;
            --span-last: 6;
        }

        &[size='medium'] {
            --span-first: 6;
            --span-last: 6;
        }

        &[size='large'] {
            --span-first: 7;
            --span-last: 5;
        }

        &.tab-item[size='large'] {
            sew-ws-richtext {
                margin-bottom: 26px;
                margin-top: 24px;
            }
        }
    }

    @include mq-1 {
        &:not([size='xxs']) {
            --span-first: 12;
            --span-last: 12;

            .main-content-container {
                .slot-wrapper {
                    *:first-child {
                        grid-column: 1 / span var(--span-first);
                        grid-row: var(--grid-row);
                    }

                    *:last-child {
                        margin-top: 32px;
                        grid-column: 1 / span var(--span-last);
                        grid-row: calc(var(--grid-row) + 1);
                    }
                }
            }
        }

        &[reverse]:not([size='xxs']) {
            .main-content-container {
                .slot-wrapper {
                    *:first-child {
                        margin-top: 32px;
                        grid-row: calc(var(--grid-row) + 1);
                    }

                    *:last-child {
                        margin-top: 0;
                        grid-row: var(--grid-row);
                    }
                }
            }
        }

        &[size='xxs'] {
            sew-ws-richtext {
                margin: 0;
            }

            --span-first: 4;
            --span-last: 8;
        }

        &[underlay] {
            .main-content-container {
                padding: 40px 0;
            }
        }

        &:not(.tab-item).has-caption {
            sew-ws-richtext {
                margin-bottom: unset;
            }
        }
    }
}
